<template>
  <i class="fa fa-fw fa-mobile"></i>
</template>

<script>
export default {
  name: 'Sms',
};
</script>

<style scoped>
.fa-mobile {
  color: #2993cf;
}
</style>



// WEBPACK FOOTER //
// SmsIcon.vue?89257d98